import React from "react";

export default function ApprovalExplanation() {
  return (
    <>
      <p>
        Now let’s try approval voting. In this method, you can choose as many
        candidates as you like. These should be candidates that you would find
        acceptable. You’re not rating them, you’re just indicating that you
        think they could do the job. As with plurality voting, the candidate
        with the most votes wins.
      </p>

      <h3>What's cool about this method?</h3>
      <ul>
        <li>
          Allowing voters to express support for multiple candidates nearly
          eliminates the problem of voting splitting.
        </li>
        <li>It tends to elect more consensus winners.</li>
        <li>
          It tends to elect candidates who would beat all rivals head-to-head.
        </li>
        <li>
          It’s not complicated. The ballots resemble the ballots voters are used
          to from the plurality method.
        </li>
        <li>
          Results are still easy to understand: a simple list of the candidates
          along with how many votes they received.
        </li>
      </ul>
      <hr />
      <p className="nextAction">
        Now try it. Pick all the candidates that you could accept, then click{" "}
        <b>Vote</b>.
      </p>
    </>
  );
}
